import React from 'react'
import styled, { css } from 'styled-components'

import { color } from 'styles/colors'

type Props = {
  isSelected?: boolean
  seriesName: string
  onSelectCallback: (e) => void
}
const CheckMark = ({ isSelected = false, seriesName, onSelectCallback }:Props) => {
  return (
    <S.Checkmark
      onClick={() => onSelectCallback(seriesName)}
      selected={isSelected}
      seriesName={seriesName}
      className="icon-checkmark"
      role="img"
      data-testid={`checkmark${seriesName}`}
      aria-label={`${isSelected ? 'deselect' : 'select'} ${seriesName}`}
    />
  )
}

export default CheckMark

const S = {
  Checkmark: styled.button.withConfig({
    shouldForwardProp: (prop) => !['seriesName'].includes(prop)
  })<{ selected: boolean, seriesName: string }>`
    right: 0px;
    padding: 3px;
    text-align: center;
    position: relative;
    cursor: pointer;

    ${({ selected }) => (selected
    ? css`
          font-weight: bold;
          color: ${color('selectedLegendCheckmark')};
        `
    : css`
          color: ${color('deselectedLegendCheckmark')};

          &:hover {
            color: ${color('deselectedLegendCheckmarkHover')};
          }
        `
  )}
`
}
